import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Users, TrendingUp, UserPlus } from 'lucide-react';

interface ActiveReferralsProps {
  newThisMonth?: number;
  activeReferrals?: number;
  conversionRate?: string;
}

const ActiveReferrals = ({
  newThisMonth = 0,
  activeReferrals = 0,
  conversionRate = '0%',
}: ActiveReferralsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Active Referrals</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="flex items-center gap-3 p-4 border rounded-lg hover:bg-muted/50 transition-colors">
            <div className="flex-shrink-0 p-2 bg-blue-100 rounded-lg">
              <UserPlus className="h-4 w-4 text-blue-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xl font-semibold text-gray-900">
                {newThisMonth}
              </p>
              <p className="text-xs text-gray-500 mt-0.5">New This Month</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 border rounded-lg hover:bg-muted/50 transition-colors">
            <div className="flex-shrink-0 p-2 bg-green-100 rounded-lg">
              <Users className="h-4 w-4 text-green-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xl font-semibold text-gray-900">
                {activeReferrals}
              </p>
              <p className="text-xs text-gray-500 mt-0.5">Active Referrals</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 border rounded-lg hover:bg-muted/50 transition-colors">
            <div className="flex-shrink-0 p-2 bg-purple-100 rounded-lg">
              <TrendingUp className="h-4 w-4 text-purple-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xl font-semibold text-gray-900">
                {conversionRate}
              </p>
              <p className="text-xs text-gray-500 mt-0.5">Conversion Rate</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ActiveReferrals;
